
































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import BaseSelectInput from '@/components/BaseSelectInput.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import {
    getPreviewPerson,
    getPreviewScorecardPersons,
    getPreviewSlug,
    getTestMode,
    toggleTestMode,
    getTestSurveysSent
} from '@/api/conversation'
import { inclusiveRange } from '@/utils/array'
import { ComponentMounter } from '@/utils/component-mounter'

interface Person {
    id: number
    name: string
}

@Component<SurveyPreview>({
    components: {
        BaseSelectInput
    }
})
export default class SurveyPreview extends Vue {
    @Prop({ type: String, required: false, default: null }) public fromName?: string
    @Prop({ type: String, required: false, default: null }) public subject?: string
    @Prop({ type: String, required: false, default: null }) public body?: string
    @Prop({ type: String, required: false, default: null }) public logo?: string
    @Prop({ type: String, required: false, default: null }) public avatar?: string
    @Prop({ type: String, required: false, default: null }) public footer?: string
    @Prop({ type: String, required: false, default: null }) public colorButton?: string
    @Prop({ type: String, required: false, default: null }) public npsLayout?: string
    @Prop({ type: String, required: false, default: null }) public labelLeft?: string
    @Prop({ type: String, required: false, default: null }) public labelRight?: string
    @Prop({ type: String, required: false, default: null }) public unsubscribe?: string
    @Prop({ type: String, required: false, default: null }) public privacy?: string
    @Prop({ type: String, required: false, default: null }) public csatVerySatisfied?: string
    @Prop({ type: String, required: false, default: null }) public csatSatisfied?: string
    @Prop({ type: String, required: false, default: null }) public csatNeutral?: string
    @Prop({ type: String, required: false, default: null }) public csatUnsatisfied?: string
    @Prop({ type: String, required: false, default: null }) public csatVeryUnsatisfied?: string
    @Prop({ type: String, required: true }) public templateKey!: string
    @Prop({ type: Boolean, required: true }) public specChanged!: boolean
    @Prop({ type: Boolean, required: true }) public hasScorecardFeature!: boolean
    @Prop({ type: Boolean, required: true }) public hasScorecardQuestion!: boolean
    @Prop(Number) public lastSave?: number

    public personId = ''
    public scorecardPersons: Person[] = []
    public scorecardPersonId = ''
    public scores = inclusiveRange(0, 10).map((score) => {
        const value = score.toString()

        return {
            value,
            label: value
        }
    })
    public score = this.scores[this.scores.length - 1].value
    public timestamp = Date.now()
    public previewSlug = ''
    public testMode = false
    public iframeHeight = '100%'

    public get queryString(): string {
        let queryString = [] as any

        if (this.fromName !== null && this.fromName?.length) {
            queryString.push('from_name=' + encodeURIComponent(this.fromName))
        }

        if (this.subject !== null && this.subject?.length) {
            queryString.push('subject=' + encodeURIComponent(this.subject))
        }

        if (this.body !== null && this.body?.length) {
            queryString.push('body=' + encodeURIComponent(this.body))
        }

        if (this.logo !== null && this.logo?.length) {
            queryString.push('logo=' + encodeURIComponent(this.logo))
        }

        if (this.avatar !== null && this.avatar?.length) {
            queryString.push('avatar=' + encodeURIComponent(this.avatar))
        }

        if (this.footer !== null && this.footer?.length) {
            queryString.push('footer=' + encodeURIComponent(this.footer))
        }

        if (this.colorButton !== null && this.colorButton?.length) {
            queryString.push('colorbutton=' + encodeURIComponent(this.colorButton))
        }

        if (this.npsLayout !== null && this.npsLayout?.length) {
            queryString.push('nps_layout=' + encodeURIComponent(this.npsLayout))
        }

        if (this.labelLeft !== null && this.labelLeft?.length) {
            queryString.push('label_left=' + encodeURIComponent(this.labelLeft))
        }

        if (this.labelRight !== null && this.labelRight?.length) {
            queryString.push('label_right=' + encodeURIComponent(this.labelRight))
        }

        if (this.unsubscribe !== null && this.unsubscribe?.length) {
            queryString.push('unsubscribe=' + encodeURIComponent(this.unsubscribe))
        }

        if (this.privacy !== null && this.privacy?.length) {
            queryString.push('privacy=' + encodeURIComponent(this.privacy))
        }

        if (this.csatVerySatisfied !== null && this.csatVerySatisfied?.length) {
            queryString.push('csat_very_satisfied=' + encodeURIComponent(this.csatVerySatisfied))
        }

        if (this.csatSatisfied !== null && this.csatSatisfied?.length) {
            queryString.push('csat_satisfied=' + encodeURIComponent(this.csatSatisfied))
        }

        if (this.csatNeutral !== null && this.csatNeutral?.length) {
            queryString.push('csat_neutral=' + encodeURIComponent(this.csatNeutral))
        }

        if (this.csatUnsatisfied !== null && this.csatUnsatisfied?.length) {
            queryString.push('csat_unsatisfied=' + encodeURIComponent(this.csatUnsatisfied))
        }

        if (this.csatVeryUnsatisfied !== null && this.csatVeryUnsatisfied?.length) {
            queryString.push('csat_very_unsatisfied=' + encodeURIComponent(this.csatVeryUnsatisfied))
        }

        return queryString.join('&')
    }

    public get iframeSrc(): string {
        let queryString = this.queryString
        if (queryString) {
            queryString = '&' + queryString
        }

        if (!this.testMode || !this.previewSlug || this.previewSlug === '') {
            return this.personId
                ? `/sm/${this.templateKey}/${this.personId}/?timestamp=${this.timestamp}${queryString}`
                : ''
        }

        return `/s/${this.previewSlug}/?simulated=1&timestamp=${this.timestamp}${queryString}`
    }

    public get hasScorecardPeople(): boolean {
        return this.scorecardPersons && this.scorecardPersons.length > 0
    }

    public get scorecardPersonOptions() {
        if (!this.hasScorecardPeople) {
            return []
        }

        return this.scorecardPersons.map((person) => {
            return {
                label: person.name,
                value: person.id.toString()
            }
        })
    }

    public get iframeStyle() {
        return {
            height: this.iframeHeight
        }
    }

    @Watch('lastSave')
    public async onLastSaveChanged() {
        await this.reloadPreview()
    }

    @Watch('iframeSrc')
    public onIFrameSrcChanged() {
        window.setTimeout(() => {
            this.calcIFrameHeight()
        }, 500)
    }

    public async mounted() {
        await Promise.all([
            this.initialiseTestMode(),
            this.initialisePreviewPerson(),
            this.initialisePreviewScorecardPersons()
        ])

        await this.setupTestSurvey()
    }

    public async reloadPreview() {
        this.timestamp = Date.now()
        await this.setupTestSurvey()
    }

    public async setupTestSurvey() {
        if (!this.testMode || !this.personId || this.personId === '') {
            return
        }

        const personId = Number(this.personId)
        const scorecardPersonId = this.scorecardPersonId && this.scorecardPersonId !== ''
            ? Number(this.scorecardPersonId)
            : undefined

        const {
            data: { success, slug }
        } = await getPreviewSlug(this.templateKey, personId, scorecardPersonId)

        if (!success) {
            throw new Error()
        }

        this.previewSlug = slug
    }

    public async switchTestMode(event: Event) {
        if (!this.testMode) {
            await this.toggleTestModeInternal()
        } else {
            // prevent default behaviour as switch value is only changed after user responds to confirmation dialog
            event.preventDefault()
            this.showDisableTestModeConfirmation()
        }
    }

    public calcIFrameHeight() {
        const iframe = this.$refs.iframe as HTMLIFrameElement | undefined

        if (!iframe || !iframe.contentWindow) {
            this.iframeHeight = '100%'
            return
        }

        const iframeDoc = iframe.contentWindow.document

        const iframeHeight = Math.max(
            Math.max(iframeDoc.body.scrollHeight, iframeDoc.documentElement.scrollHeight),
            Math.max(iframeDoc.body.offsetHeight, iframeDoc.documentElement.offsetHeight),
            Math.max(iframeDoc.body.clientHeight, iframeDoc.documentElement.clientHeight)
        )

        this.iframeHeight = `${iframeHeight}px`
    }

    private async showDisableTestModeConfirmation() {
        const shouldConfirmDelete = await this.hasTestSurveys()
        if (!shouldConfirmDelete) {
            await this.toggleTestModeInternal()
            return
        }

        const container = this.$refs.container as Element
        const propsData = {
            title: 'Remove Preview Test Responses',
            message: 'Turning the recording of preview responses off will remove the preview responses from the survey reporting. Any real responses to surveys that were send will be unaffected.',
            okCaption: 'Continue',
            cancelCaption: 'Not yet',
            visible: true
        }
        const dialogInstance = ComponentMounter.mount(ConfirmDialog, container, propsData, this.$store)

        dialogInstance.$once('ok', async () => {
            await this.toggleTestModeInternal()

            dialogInstance.$destroy()
        })

        dialogInstance.$once('cancel', () => {
            dialogInstance.$destroy()
        })
    }

    private async hasTestSurveys() {
        const { data } = await getTestSurveysSent(this.templateKey)
        if (isNaN(data)) {
            return true // better to assume true and display the modal
        }
        return data > 0
    }

    private async toggleTestModeInternal() {
        this.testMode = !this.testMode
        await toggleTestMode(this.templateKey, this.testMode)
        await this.setupTestSurvey()
    }

    private async initialiseTestMode() {
        const { data } = await getTestMode(this.templateKey)

        if (data) {
            this.testMode = data
        }
    }

    private async initialisePreviewPerson() {
        const { data } = await getPreviewPerson()

        this.personId = data
    }

    private async initialisePreviewScorecardPersons() {
        if (!this.hasScorecardFeature || !this.hasScorecardQuestion) {
            return
        }

        const { data } = await getPreviewScorecardPersons()

        this.scorecardPersons = data

        if (this.scorecardPersons && this.scorecardPersons.length > 0) {
            this.scorecardPersonId = this.scorecardPersonOptions[0].value
        }
    }
}
